import React from 'react';
import KakaoAdBanner from './KakaoAdBanner';

function Home({ onNavigate }) {

  return (
    <div className="bg-gradient-primary min-vh-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-12 col-md-9">
            
            {/* 메인 헤더 */}
            <div className="text-center py-5">
              <h1 className="h1 text-white mb-4">
                <i className="fas fa-piggy-bank me-3"></i>
                라떼비버 노후연금 계산기
              </h1>
              <p className="lead text-white-50 mb-0">
                두 가지 방식으로 노후 자금을 계획해보세요
              </p>
            </div>

            {/* 카카오 애드핏 배너 */}
            <KakaoAdBanner className="mb-4" />

            {/* 소개 섹션 */}
            <div className="card shadow mb-5">
              <div className="card-body text-center py-5">
                <h2 className="h3 text-gray-900 mb-4">
                  어떤 방식으로 계산하시겠습니까?
                </h2>
                <p className="text-gray-600 mb-0">
                  저축액에서 생활비를 계산하거나, 원하는 생활비에서 필요한 저축액을 계산할 수 있습니다.
                </p>
              </div>
            </div>

            {/* 계산기 선택 카드 */}
            <div className="row">
              
              {/* 일반 계산기 */}
              <div className="col-xl-6 col-md-6 mb-4">
                <div className="card border-left-primary shadow h-100 calculator-card" 
                     onClick={() => onNavigate('forward')}
                     style={{cursor: 'pointer', transition: 'all 0.3s'}}>
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col">
                        <div className="text-center">
                          <div className="text-primary mb-3" style={{fontSize: '4rem'}}>
                            <i className="fas fa-calculator"></i>
                          </div>
                          <div className="text-xs font-weight-bold text-primary text-uppercase mb-3">
                            Forward Calculator
                          </div>
                          <div className="h4 mb-3 font-weight-bold text-gray-800">
                            일반 계산기
                          </div>
                          <p className="text-gray-600 mb-4">
                            <strong>월 저축액 → 노후 생활비</strong><br/>
                            매월 얼마씩 저축하면 노후에 얼마나 쓸 수 있는지 계산합니다.
                          </p>
                          
                          <div className="card bg-light mb-3">
                            <div className="card-body py-3">
                              <h6 className="font-weight-bold mb-2">📋 입력 항목</h6>
                              <ul className="list-unstyled text-sm text-left mb-0">
                                <li><i className="fas fa-check text-success me-2"></i>현재 나이</li>
                                <li><i className="fas fa-check text-success me-2"></i>은퇴 나이</li>
                                <li><i className="fas fa-check text-success me-2"></i>월 납입액</li>
                                <li><i className="fas fa-check text-success me-2"></i>수익률</li>
                                <li><i className="fas fa-check text-success me-2"></i>배당률</li>
                              </ul>
                            </div>
                          </div>

                          <div className="card mb-4" style={{backgroundColor: 'rgba(255, 193, 7, 0.1)'}}>
                            <div className="card-body py-3">
                              <h6 className="font-weight-bold mb-2">📈 계산 결과</h6>
                              <ul className="list-unstyled text-sm text-left mb-0">
                                <li><i className="fas fa-arrow-right text-warning me-2"></i>최종 적립액</li>
                                <li><i className="fas fa-star text-warning me-2"></i><strong>매월 사용 가능한 현금흐름</strong></li>
                                <li><i className="fas fa-chart-line text-warning me-2"></i>적립 과정 시뮬레이션</li>
                              </ul>
                            </div>
                          </div>

                          <button className="btn btn-primary w-100 btn-lg">
                            <i className="fas fa-play me-2"></i>
                            일반 계산기 사용하기
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 역산 계산기 */}
              <div className="col-xl-6 col-md-6 mb-4">
                <div className="card border-left-success shadow h-100 calculator-card" 
                     onClick={() => onNavigate('reverse')}
                     style={{cursor: 'pointer', transition: 'all 0.3s'}}>
                  <div className="card-body">
                    <div className="row no-gutters align-items-center">
                      <div className="col">
                        <div className="text-center">
                          <div className="text-success mb-3" style={{fontSize: '4rem'}}>
                            <i className="fas fa-bullseye"></i>
                          </div>
                          <div className="text-xs font-weight-bold text-success text-uppercase mb-3">
                            Reverse Calculator
                          </div>
                          <div className="h4 mb-3 font-weight-bold text-gray-800">
                            역산 계산기
                          </div>
                          <p className="text-gray-600 mb-4">
                            <strong>원하는 생활비 → 필요 저축액</strong><br/>
                            노후에 원하는 생활비를 위해 지금부터 얼마씩 저축해야 하는지 계산합니다.
                          </p>
                          
                          <div className="card bg-light mb-3">
                            <div className="card-body py-3">
                              <h6 className="font-weight-bold mb-2">📋 입력 항목</h6>
                              <ul className="list-unstyled text-sm text-left mb-0">
                                <li><i className="fas fa-check text-success me-2"></i>현재 나이</li>
                                <li><i className="fas fa-check text-success me-2"></i>은퇴 나이</li>
                                <li><i className="fas fa-star text-warning me-2"></i><strong>원하는 월 생활비</strong></li>
                                <li><i className="fas fa-check text-success me-2"></i>수익률</li>
                                <li><i className="fas fa-check text-success me-2"></i>배당률</li>
                              </ul>
                            </div>
                          </div>

                          <div className="card mb-4" style={{backgroundColor: 'rgba(25, 135, 84, 0.1)'}}>
                            <div className="card-body py-3">
                              <h6 className="font-weight-bold mb-2">📈 계산 결과</h6>
                              <ul className="list-unstyled text-sm text-left mb-0">
                                <li><i className="fas fa-arrow-right text-success me-2"></i>필요한 최종 적립액</li>
                                <li><i className="fas fa-star text-warning me-2"></i><strong>매월 저축해야 할 금액</strong></li>
                                <li><i className="fas fa-chart-line text-success me-2"></i>저축 과정 시뮬레이션</li>
                              </ul>
                            </div>
                          </div>

                          <button className="btn btn-success w-100 btn-lg">
                            <i className="fas fa-play me-2"></i>
                            역산 계산기 사용하기
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {/* 비교 표 */}
            <div className="card shadow mb-5">
              <div className="card-header py-3">
                <h3 className="m-0 font-weight-bold text-primary text-center">
                  <i className="fas fa-chart-bar me-2"></i>
                  두 계산기 비교
                </h3>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="bg-light">
                      <tr>
                        <th className="font-weight-bold text-gray-800">구분</th>
                        <th className="text-center font-weight-bold text-primary">
                          <i className="fas fa-calculator me-1"></i>
                          일반 계산기
                        </th>
                        <th className="text-center font-weight-bold text-success">
                          <i className="fas fa-bullseye me-1"></i>
                          역산 계산기
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="font-weight-bold">계산 방향</td>
                        <td className="text-center">저축액 → 생활비</td>
                        <td className="text-center">생활비 → 저축액</td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">핵심 질문</td>
                        <td className="text-center">
                          <small>"월 100만원 저축하면<br/>노후에 얼마나 쓸 수 있을까?"</small>
                        </td>
                        <td className="text-center">
                          <small>"노후에 월 300만원 쓰려면<br/>지금부터 얼마씩 저축해야 할까?"</small>
                        </td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">사용 상황</td>
                        <td className="text-center">
                          <small>현재 저축 여력이 정해진 경우</small>
                        </td>
                        <td className="text-center">
                          <small>목표 생활 수준이 정해진 경우</small>
                        </td>
                      </tr>
                      <tr>
                        <td className="font-weight-bold">주요 결과</td>
                        <td className="text-center">
                          <span className="badge bg-primary">매월 현금흐름</span>
                        </td>
                        <td className="text-center">
                          <span className="badge bg-success">필요 월 저축액</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* 푸터 정보 */}
            <div className="card shadow mb-4">
              <div className="card-body text-center py-4">
                <div className="text-gray-600">
                  <p className="mb-3">
                    <i className="fas fa-info-circle text-info me-2"></i>
                    <strong>참고</strong>: 이 계산기는 교육/참고 목적으로만 사용하시고, 실제 투자 결정 시에는 전문가와 상담하시기 바랍니다.
                  </p>
                  <p className="mb-0">
                    <i className="fas fa-chart-pie text-warning me-2"></i>
                    복리 계산과 배당 수익을 고려한 시뮬레이션 결과입니다.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      
      <style jsx>{`
        .calculator-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
        }
      `}</style>
    </div>
  );
}

export default Home;
